import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../../utils/massActions'
import { isSubArchive } from '../../../../utils/route'
import { getSelectDropdownListDividerOption } from '../../../Select'
import {
  EMAIL_ACTION_ATTACH_REQUEST,
  EMAIL_ACTION_COPY_TO,
  EMAIL_ACTION_CREATE_APPOINTMENT,
  EMAIL_ACTION_CREATE_SERVICE_REQUEST,
  EMAIL_ACTION_VIEW_ENTIRE_MESSAGE,
  EMAIL_PROFILE_ACTION_ADD_NOTE,
  EMAIL_PROFILE_ACTION_ARCHIVE,
  EMAIL_PROFILE_ACTION_DOWNLOAD_FILES,
  EMAIL_PROFILE_ACTION_FORWARD,
  EMAIL_PROFILE_ACTION_MARK_AS_IMPORTANT,
  EMAIL_PROFILE_ACTION_MARK_AS_UNIMPORTANT,
  EMAIL_PROFILE_ACTION_MARK_AS_UNREAD,
  EMAIL_PROFILE_ACTION_MESSAGE_RESEND,
  EMAIL_PROFILE_ACTION_PRINT,
  EMAIL_PROFILE_ACTION_REPLY,
  EMAIL_PROFILE_ACTION_REPLY_ALL,
  EMAIL_PROFILE_ACTION_RESTORE,
} from '../../Email.constants'

import ArchiveIcon from '../../../../icons/archive.svg'
import EmailCopyIcon from '../../../../icons/email-copy.svg'
import PrintIcon from '../../../../icons/print.svg'
import RestoreIcon from '../../../../icons/restore.svg'

export function getActions({ permissions = EMPTY_OBJECT, sub, t }) {
  const items = [
    {
      Icon: EmailCopyIcon,
      permission: permissions.can_copy_to_archive,
      tooltip: t('EmailProfile.LetterActionCopyToEntityProfileTooltipKey'),
      value: EMAIL_ACTION_COPY_TO,
    },
    {
      Icon: PrintIcon,
      permission: true,
      tooltip: t('EmailProfile.LetterActionPrintTooltipKey'),
      value: EMAIL_PROFILE_ACTION_PRINT,
    },
    {
      Icon: ArchiveIcon,
      permission: permissions.can_archive && !isSubArchive(sub),
      tooltip: t('EmailProfile.LetterActionArchiveTooltipKey'),
      value: EMAIL_PROFILE_ACTION_ARCHIVE,
    },
    {
      Icon: RestoreIcon,
      permission: permissions.can_restore && isSubArchive(sub),
      tooltip: t('EmailProfile.LetterActionRestoreTooltipKey'),
      value: EMAIL_PROFILE_ACTION_RESTORE,
    },
  ]

  return filterPermittedActionsWithDividers(items)
}

export function getEmailProfileMessageHeaderActions({
  data,
  isAppointmentAvailable,
  sub,
  t,
}) {
  const {
    files = EMPTY_LIST,
    has_raw_text: hasRawText,
    permissions = EMPTY_OBJECT,
    starred,
  } = data || EMPTY_OBJECT

  const items = [
    {
      label: t('Emails.ResendActionOptionKey'),
      permission: permissions.can_resend,
      value: EMAIL_PROFILE_ACTION_MESSAGE_RESEND,
    },
    {
      label: t('Emails.ReplyActionOptionKey'),
      permission: permissions.can_reply,
      value: EMAIL_PROFILE_ACTION_REPLY,
    },
    {
      label: t('Emails.ReplyAllActionOptionKey'),
      permission: permissions.can_reply,
      value: EMAIL_PROFILE_ACTION_REPLY_ALL,
    },
    {
      label: t('Emails.ForwardActionOptionKey'),
      permission: permissions.can_reply,
      value: EMAIL_PROFILE_ACTION_FORWARD,
    },
    {
      label: t('Emails.MarkAsStarredActionOptionKey'),
      permission: permissions.can_edit_starred && !starred,
      value: EMAIL_PROFILE_ACTION_MARK_AS_IMPORTANT,
    },
    {
      label: t('Emails.MarkAsUnstarredActionOptionKey'),
      permission: permissions.can_edit_starred && starred,
      value: EMAIL_PROFILE_ACTION_MARK_AS_UNIMPORTANT,
    },
    {
      label: t('Emails.AddNoteActionOptionKey'),
      permission: permissions.can_edit_note,
      value: EMAIL_PROFILE_ACTION_ADD_NOTE,
    },
    {
      label: t('Emails.ViewEntireMessageActionOptionKey'),
      permission: hasRawText,
      value: EMAIL_ACTION_VIEW_ENTIRE_MESSAGE,
    },
    {
      label: t('Emails.MarkAsUnreadActionOptionKey'),
      permission: permissions.can_edit_unread_status,
      value: EMAIL_PROFILE_ACTION_MARK_AS_UNREAD,
    },
    {
      label: t('Emails.CreateServiceRequestActionOptionKey'),
      permission: permissions.can_create_request,
      value: EMAIL_ACTION_CREATE_SERVICE_REQUEST,
    },
    {
      label: t('Emails.AttachServiceRequestActionOptionKey'),
      permission: permissions.can_attach_to_request,
      value: EMAIL_ACTION_ATTACH_REQUEST,
    },
    {
      label: t('Appointment.CreateFromEmailKey'),
      permission: isAppointmentAvailable,
      value: EMAIL_ACTION_CREATE_APPOINTMENT,
    },
    {
      label: t('Emails.CopyToEntityProfileActionOptionKey'),
      permission: permissions.can_copy_to_archive,
      value: EMAIL_ACTION_COPY_TO,
    },
    {
      label: t('Emails.DownloadFilesActionOptionKey'),
      permission: files.length > 0,
      value: EMAIL_PROFILE_ACTION_DOWNLOAD_FILES,
    },
    {
      label: t('Emails.PrintActionOptionKey'),
      permission: true,
      value: EMAIL_PROFILE_ACTION_PRINT,
    },
    getSelectDropdownListDividerOption(),
    {
      label: t('Emails.ArchiveActionOptionKey'),
      permission: permissions.can_archive && !isSubArchive(sub),
      value: EMAIL_PROFILE_ACTION_ARCHIVE,
    },
    {
      label: t('Emails.RestoreActionOptionKey'),
      permission: permissions.can_restore && isSubArchive(sub),
      value: EMAIL_PROFILE_ACTION_RESTORE,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}
